export enum MouseInteraction {
  // Basic mouse events
  Click = "click",
  DoubleClick = "dblclick",
  MouseDown = "mousedown",
  MouseUp = "mouseup",
  MouseMove = "mousemove",
  MouseOver = "mouseover",
  MouseOut = "mouseout",
  MouseEnter = "mouseenter",
  MouseLeave = "mouseleave",

  // Context menu
  ContextMenu = "contextmenu",

  // Wheel events
  Wheel = "wheel",

  // Touch events
  TouchStart = "touchstart",
  TouchEnd = "touchend",
  TouchMove = "touchmove",
  TouchCancel = "touchcancel",

  // Drag events
  Drag = "drag",
  DragStart = "dragstart",
  DragEnd = "dragend",

  // Map-specific interaction events
  MapClick = "click",
  MapDoubleClick = "dblclick",
  MapMouseDown = "mousedown",
  MapMouseUp = "mouseup",
  MapMouseMove = "mousemove",
  MapMouseEnter = "mouseenter",
  MapMouseLeave = "mouseleave"
}

export enum MapInteraction {
  Move = "move",
  MoveStart = "movestart",
  MoveEnd = "moveend",
  Zoom = "zoom",
  ZoomStart = "zoomstart",
  ZoomEnd = "zoomend",
  Rotate = "rotate",
  RotateStart = "rotatestart",
  RotateEnd = "rotateend",
  Pitch = "pitch",
  PitchStart = "pitchstart",
  PitchEnd = "pitchend",
  Idle = "idle"
}
